<template>
    <table class="table shadow-sm fs-6 fw-bold gs-0 gy-2 m-0 mb-5 " style="border-radius: 8px;height: 500px!important;">
        <tbody>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-6">
                    <h3 class="fs-1 mt-2">{{$t('appointments.details')}}</h3>
                </td>
                <td class="px-5 py-6 text-end pe-5">
                    <Button v-if="$can(abilities.UPDATE_APPOINTMENT) || $can(abilities.UPDATE_ALL_APPOINTMENT)" type="new" btn-class="btn-sm" v-show="appointment.status != 'CANCELLED' && appointment.status != 'COMPLETED'"  btn-text="appointments.update" @click="goToUpdate"></Button>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.name') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{creator?.fullname}}</span>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.start_date') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.start_time}}</span>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.end_date') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.end_time}}</span>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.canal') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.appointmentType?.name}}</span>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.place') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.location}}</span>
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.room') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.appointment_room?.name}}</span>
                </td>
            </tr>
            <tr v-if="appointment.link" style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.link') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                    <span class="text-gray-800 text-hover-primary">{{appointment?.link}}</span>
                </td>
            </tr>
            <tr v-if="appointment.status == 'SCHEDULED' && appointment.frequency_count_appointment" style="border-bottom: 1px solid #CCCFD3;">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.reminder') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                        <span class="text-gray-800 text-hover-primary">
                            {{appointment?.frequency_count_appointment}} {{getFrequencyName(appointment?.frequency_appointment)[locale]}}
                        </span>
                </td>
            </tr>

            <tr style="border-bottom: 1px solid #CCCFD3;" v-if="appointment?.description">
                <td class="px-5 py-5 text-gray-400">{{ $t('appointments.label.description') }}</td>
                <td class="py-5 text-gray-800 text-start pe-5">
                        <span class="text-gray-800 text-hover-primary" v-html="appointment?.description"></span>
                </td>
            </tr>

            <tr style="border-bottom: 1px solid #CCCFD3;" v-if="appointment?.projects?.length">
              <td class="px-5 py-5 text-gray-400">
                {{ $t('appointments.label.projects') }}
              </td>
              <td class="py-5 text-gray-800 text-start pe-5">
                <ul class="list-disc ps-4">
                  <li v-for="project in appointment.projects" :key="project.id">
                    <span class="text-gray-800 text-hover-primary">{{ project.title }}</span>
                  </li>
                </ul>
              </td>
            </tr>

        </tbody>
    </table>
</template>

<script setup>
import Button from "@/components/Button.vue";
import { useRouter, useRoute } from 'vue-router';
import {computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import abilities from "@/composables/abilities";

const {locale} = useLocales()
const router = useRouter()
const route = useRoute()
const store = useStore()

const props = defineProps({
  appointment: Object
})

const users = computed(() => store.getters["user/getUsers"])
const creator = computed(() => users.value?.filter(item => item.id == props.appointment?.creator_id)[0])
const frequencyEnum = computed(() => store.getters["appointments/getFrequencyEnum"])

function goToUpdate(){
    router.push({name: 'appointments-edit', params: {id: route.params.id}})
}

function getFrequencyName(val) {
  const {fr, en} = frequencyEnum.value.find(el => el.value === val) || ''
  return {fr, en}
}

onMounted(() => {
    store.dispatch('user/loadUsers')
    store.dispatch('appointments/loadFrequencyEnum')
})
</script>